import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';
import { css } from 'styled-components';

interface StyledProps {
  bgColor?: boolean;
  isSelected?: boolean;
  imageLoaded?: boolean;
  color?: string;
}

export const Container = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: 0.2s ease;
  ${(props: StyledProps) =>
    props.bgColor &&
    css`
      background-color: ${(props: StyledProps) => props.bgColor};
    `};
  ${(props: StyledProps) =>
    props.isSelected
      ? css`
          box-shadow: 0px 0px 0px 3rem ${COLORS.GREEN};
        `
      : css`
          box-shadow: 0px 0px 0px 3rem ${COLORS.WHITE};
          &:hover {
            box-shadow: 0px 0px 0px 3rem ${COLORS.GREEN};
          }
        `}

  ${respondTo.bigPhone`
    width: 280rem;
  `}

  :focus-visible {
    outline: none;
    box-shadow: 0 0 0 1rem ${COLORS.GREEN};
  }
`;

export const imageStyle = css`
  max-height: 188px;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10rem 15rem;
  gap: 10rem;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.label`
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  min-height: 50rem;
  ${(props: StyledProps) =>
    props.color &&
    css`
      color: ${props.color};
    `};
  word-break: break-word;

  ${respondTo.bigTablet`
    font-size: 16rem;
  `}
`;

export const ColorCode = styled.label`
  color: ${COLORS.BLACK};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  ${(props: StyledProps) =>
    props.color &&
    css`
      color: ${props.color};
    `};
  line-break: normal;
`;

export const ColorCollection = styled.span`
  display: block;
  font-size: 12px;
  color: ${COLORS.BLACK};

  ${(props: StyledProps) =>
    props.color &&
    css`
      color: ${props.color};
    `};
`;
